import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteWithLines } from './types';

const HUBSPOT_DEAL_REFRESH_INTERVAL_MS = 2000;

export function useBillingQuote(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingQuoteWithLines>(
    quoteId ? `commenda-billing/quotes/${quoteId}` : null,
    SWRFetcher({ method: 'GET' }),
    {
      refreshInterval: (latest) =>
        latest?.status === 'PUBLISHED' && !latest.hubspotDealId
          ? HUBSPOT_DEAL_REFRESH_INTERVAL_MS
          : 0,
    }
  );

  return { quote: data ?? null, error, isLoading, mutate };
}
